import React from "react";
import ServicePage from "./Components/ServiceComponent";
import uiuxImage from "../../assets/img/binary-2904980_1920.webp";
import backgroundDesign from "../../assets/img/bannierservice.jpg";
import { FaDesktop, FaCog, FaNetworkWired, FaRadiation, FaSoundcloud } from "react-icons/fa";
import { Antenna, MapPin, Microwave, SwitchCamera } from "lucide-react";
import IntlMessages from "../../intl/IntlMessages";
import { FiPower, FiSunrise } from "react-icons/fi";

const styles = {
  descriptionContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
  },
  iconText: {
    marginLeft: "0.5rem",
  },
};

const UIDesign = () => {
  return (
    <ServicePage
      title={<IntlMessages id="telecom.telecom" />}
      description={
        <div>
          <p>
            <IntlMessages id="telecom.TextTelecom" />
          </p>
          <p>
            <IntlMessages id="telecom.subTextTelecom" />
          </p>
          <div style={styles.descriptionContainer}>
            <div style={styles.iconContainer}>
              <SwitchCamera size={24} />
              <span style={styles.iconText}>
                <IntlMessages id="telecom.camera" />
              </span>
            </div>
            <div style={styles.iconContainer}>
              <FaDesktop size={24} />
              <span style={styles.iconText}>
                <IntlMessages id="telecom.tower" />
              </span>
            </div>
            <div style={styles.iconContainer}>
              <FaNetworkWired size={24} />
              <span style={styles.iconText}>
                <IntlMessages id="telecom.Wa" />
              </span>
            </div>
            <div style={styles.iconContainer}>
              <MapPin size={24} />
              <span style={styles.iconText}>
                <IntlMessages id="telecom.sig" />
              </span>
            </div>
            <div style={styles.iconContainer}>
              <FaCog size={24} />
              <span style={styles.iconText}>
                <IntlMessages id="telecom.config" />
              </span>
            </div>
            <div style={styles.iconContainer}>
              <FaRadiation size={24} />
              <span style={styles.iconText}>
                <IntlMessages id="telecom.ran" />
              </span>
            </div>
            <div style={styles.iconContainer}>
              <Antenna size={24} />
              <span style={styles.iconText}>
                <IntlMessages id="telecom.ruralStar" />
              </span>
            </div>
            <div style={styles.iconContainer}>
              <FaSoundcloud size={24} />
              <span style={styles.iconText}>
                <IntlMessages id="telecom.microwaves" />
              </span>
            </div>
            <div style={styles.iconContainer}>
              <FiSunrise size={24} />
              <span style={styles.iconText}>
                <IntlMessages id="telecom.solar" />
              </span>
            </div>
            <div style={styles.iconContainer}>
              <FiPower size={24} />
              <span style={styles.iconText}>
                <IntlMessages id="telecom.power" />
              </span>
            </div>
          </div>
        </div>
      }
      imageUrl={uiuxImage}
      altText="UI/UX Design Illustration"
      heroBackgroundImage={backgroundDesign}
    />
  );
};

export default UIDesign;
